// extracted by mini-css-extract-plugin
export default {"container":"FeedbackBookCard_container__nGwzA","text":"FeedbackBookCard_text__ZUPWO","text_feedback":"FeedbackBookCard_text_feedback__q3mk+","name":"FeedbackBookCard_name__jar9T"};